/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
// eslint-disable-next-line react/prop-types
function Reactivation({ width = 19.06, height = 18.93, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 19.06 18.93"
      {...props}
    >
      <defs>
        <style>
          {
            ".cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#77c043;}.cls-3{fill:#fff;}"
          }
        </style>
      </defs>
      <path
        className="cls-1"
        d="m10.19,18.7c-.45.09-.77.21-1.09.21-2.26.02-4.52.03-6.78,0-1.3-.02-2.28-1-2.3-2.29-.03-1.92-.04-3.84,0-5.75.02-1.36,1-2.33,2.37-2.35,2.24-.03,4.48-.02,6.72,0,.31,0,.63.11,1.1.19-1.67,1.36-2.54,2.99-2.55,5,0,2.01.87,3.61,2.53,4.99Z"
      />
      <path
        className="cls-2"
        d="m19.06,13.75c0,2.91-2.26,5.16-5.17,5.18-2.98.01-5.24-2.26-5.23-5.24.01-2.96,2.27-5.19,5.23-5.16,2.97.02,5.18,2.25,5.17,5.23Zm-6.13.74c-.35-.4-.66-.77-.97-1.13-.22-.26-.51-.44-.76-.14-.12.14-.07.52.04.72.16.3.44.52.66.79,1.03,1.26.94,1.07,2.05.15.82-.69,1.64-1.39,2.45-2.08.24-.21.48-.44.2-.76-.29-.34-.58-.16-.84.06-.14.12-.28.24-.41.36-.78.67-1.57,1.33-2.41,2.05Z"
      />
      <path
        className="cls-1"
        d="m5.69,0c2.13-.01,3.83,1.68,3.84,3.81,0,2.02-1.73,3.75-3.77,3.76-2.11,0-3.82-1.72-3.81-3.85C1.96,1.7,3.66.01,5.69,0Z"
      />
      <path
        className="cls-1"
        d="m13.86,7.55c-1.56,0-2.81-1.24-2.82-2.81,0-1.56,1.24-2.84,2.79-2.85,1.57,0,2.88,1.29,2.87,2.85,0,1.54-1.29,2.81-2.84,2.82Z"
      />
      <path
        className="cls-3"
        d="m12.93,14.49c.84-.71,1.62-1.38,2.41-2.05.14-.12.28-.24.41-.36.26-.22.55-.41.84-.06.27.32.04.56-.2.76-.82.7-1.63,1.4-2.45,2.08-1.11.92-1.02,1.12-2.05-.15-.22-.
27-.5-.49-.66-.79-.11-.2-.15-.57-.04-.72.25-.3.54-.12.76.14.31.36.63.73.97,1.13Z"
      />
    </svg>
  );
}
export default Reactivation;
